var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoSidebarTest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 6.5L5.30384 7.67346C5.50562 7.85506 5.81544 7.84248 6.00183 7.64512L8.5 5",
    stroke: "#0D0E11",
    strokeOpacity: 0.29,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 11.5L5.30384 12.6735C5.50562 12.8551 5.81544 12.8425 6.00183 12.6451L8.5 10",
    stroke: "#0D0E11",
    strokeOpacity: 0.29,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 16.5L5.30384 17.6735C5.50562 17.8551 5.81544 17.8425 6.00183 17.6451L8.5 15",
    stroke: "#0D0E11",
    strokeOpacity: 0.29,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 6.5H20.5",
    stroke: "#0D0E11",
    strokeOpacity: 0.29,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11 12H20.5",
    stroke: "#0D0E11",
    strokeOpacity: 0.29,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11 17H20.5",
    stroke: "#0D0E11",
    strokeOpacity: 0.29,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSidebarTest);
export default __webpack_public_path__ + "static/media/ico_sidebar_test.ea3c59ffab7b97175849bc2f43d76e2b.svg";
export { ForwardRef as ReactComponent };